import { TableBody } from '@mui/material';
import React from 'react';

import NewArrivalRow from '../NewArrivalRow';

const TableNewArrivalBody = ({ listArtwork }) => {
  return (
    <TableBody>
      {listArtwork.map((artwork) => (
        <NewArrivalRow
          key={artwork?.id}
          artwork={artwork}
        />
      ))}
    </TableBody>
  );
};

export default TableNewArrivalBody;
